import CallLogCallCtrlContainer from './CallLogCallCtrlContainer';

export * from './CallLogCallCtrl';
export default CallLogCallCtrlContainer;
